import { handleErrors } from "../utils/api-utils";

export async function logout(finallyCallback: (() => void) | null | undefined) {
    fetch("/api/Identity/Logout")
        .then(handleErrors)
        .catch(console.error)
        .finally(finallyCallback);
};